// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { Auth } from 'app/scripts/db/auth';
import { Util } from 'app/scripts/lib/util';
import { View } from 'app/scripts/views/internal/view';
import template from 'app/scripts/views/templates/invitee-orientation';
import { idToDate } from '@trello/dates';

class InviteeOrientationView extends View {
  static initClass() {
    this.prototype.className = 'invitee-orientation-wrapper';

    this.prototype.events = { 'click .js-close-orientation': 'onClose' };
  }

  initialize() {
    // This view can only be rendered once, as re-rendering would run the
    // animations again. It's safe to only render once because the information
    // here is static - we do not depend on api requests or websocket messages.
    return (this.hasRendered = false);
  }

  getInviteToken() {
    return Util.inviteTokenFor(this.model.id);
  }

  shouldSeePopover() {
    // you should see the popover if:
    return (
      // 1) you are logged in
      Auth.isLoggedIn() &&
      // 2) you haven't dismissed the popover before
      !Auth.me().isDismissed('invitee-orientation') &&
      // 3) you have an invite token for this board
      this.getInviteToken() &&
      // 4) your account is newer than the threshold
      idToDate(Auth.myId()) >= new Date('2019-06-15')
    );
  }

  render() {
    if (!this.shouldSeePopover() || this.hasRendered) {
      return this;
    }

    this.$el.html(template);

    const $messageContainer = this.$el.find(
      '.invitee-orientation-message-container',
    );
    const $avatarContainer = this.$el.find(
      '.invitee-orientation-avatar-container',
    );
    setTimeout(() => $avatarContainer.addClass('active'), 1200);
    setTimeout(() => $messageContainer.addClass('active'), 1350);

    this.hasRendered = true;

    return this;
  }

  onClose() {
    Auth.me().dismiss('invitee-orientation');
    return this.remove();
  }
}

InviteeOrientationView.initClass();
export { InviteeOrientationView };
